<template>

    <div>
 <v-row no-gutters>
      <base-header>
        <div slot="page-header">Dashboard2</div>
      </base-header>
    </v-row>

        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <v-card class="text-center ma-3 pa-3" color="green" dark max-width="600">
                    <v-card-text>
                        <v-sheet color="rgba(0, 0, 0, .12)">
                            <v-sparkline :value="value" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                                stroke-linecap="round" smooth>
                                <template v-slot:label="item">
                                    ${{ item.value }}
                                </template>
                            </v-sparkline>
                        </v-sheet>
                    </v-card-text>

                    <v-card-text>
                        <div class="text-h4 font-weight-bolder">
                            BTCUSDT
                        </div>
                    </v-card-text>


                </v-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <v-card class="text-center ma-3 pa-3" color="red" dark max-width="600">
                    <v-card-text>
                        <v-sheet color="rgba(0, 0, 0, .12)">
                            <v-sparkline :value="value" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                                stroke-linecap="round" smooth>
                                <template v-slot:label="item">
                                    ${{ item.value }}
                                </template>
                            </v-sparkline>
                        </v-sheet>
                    </v-card-text>

                    <v-card-text>
                        <div class="text-h4 font-weight-bolder">
                            ETHUSDT
                        </div>
                    </v-card-text>


                </v-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <v-card class="text-center ma-3 pa-3" color="green" dark max-width="600">
                    <v-card-text>
                        <v-sheet color="rgba(0, 0, 0, .12)">
                            <v-sparkline :value="value" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                                stroke-linecap="round" smooth>
                                <template v-slot:label="item">
                                    ${{ item.value }}
                                </template>
                            </v-sparkline>
                        </v-sheet>
                    </v-card-text>

                    <v-card-text>
                        <div class="text-h4 font-weight-bolder">
                            ZILUSDT
                        </div>
                    </v-card-text>


                </v-card>
            </v-col>
          <v-col cols="12" lg="3" xl="3">
                <v-card class="text-center ma-3 pa-3" color="red" dark max-width="600">
                    <v-card-text>
                        <v-sheet color="rgba(0, 0, 0, .12)">
                            <v-sparkline :value="value" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                                stroke-linecap="round" smooth>
                                <template v-slot:label="item">
                                    ${{ item.value }}
                                </template>
                            </v-sparkline>
                        </v-sheet>
                    </v-card-text>

                    <v-card-text>
                        <div class="text-h4 font-weight-bolder">
                            LTOUSDT
                        </div>
                    </v-card-text>


                </v-card>
            </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <card-search></card-search>
            </v-col>
            <v-col cols="12" sm="9">
                <v-card class="pa-2 ma-2" outlined tile>
                    <v-card-text>
                        <chart-trader></chart-trader>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <card-exchange></card-exchange>
            </v-col>
         <v-col cols="12" lg="6" xl="6">
                <card-transaction></card-transaction>
            </v-col>

          <v-col cols="12" lg="3" xl="3">
                <card-exchange></card-exchange>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" lg="12" xl="12">

                <card-tab></card-tab>
            </v-col>
        </v-row>
    </div>
</template>

<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";
    import CardSearch from '../../components/Cards/CardSearch.vue'
    import CardExchange from '../../components/Cards/CardExchange'
    import CardTab from '../../components/Cards/CardTab'
    import CardTransaction from '../../components/Cards/CardTransaction'

    import ChartTrader from '../../components/Charts/ChartTrader'
    export default {
        components: {
            BaseCard,BaseHeader,
            CardExchange,
            CardSearch,
            CardTab,
            CardTransaction,
            ChartTrader

        },
        data: () => ({
            value: [
                423,
                446,
                675,
                510,
                590,
                610,
                760,
            ],
        }),
    }
</script>